var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#82cec4;}.cls-5{fill:#442114;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 4 mirroir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.7,
    cy: 219.5,
    r: 169
  }), /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1162.16,1195.56s53.45,52.8,13.83,71.62-63.47-44.45-63.47-44.45Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1062.78,1033.59s-71.1-46.89-83.43,31.06l125.74,171.45s46.06-9.41,65.9-41.91C1130.37,1130.8,1062.78,1033.59,1062.78,1033.59Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1072.7,1252.5v-203s0-50-66-50-66,40-66,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M840.7,1458.5s47-165.77,105-205.88c57,98.88,45.34,143.94,45.34,143.94S943.7,1464.5,938.7,1506.5c0,0,5,9,2,18s-25,52-25,52l-157-75S784.7,1422.5,840.7,1458.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1072.7,1252.5s2,103,58,184c14,0,41,71,41,71l-156,69s-35-55,19-85c-30-46-94-175-94-239Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M913.7,1234.5s-34,67-64,35,23-74,23-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1037.7,1090.5s23-82-55-70l-125,172s23,41,60,50C965.7,1184.5,1037.7,1090.5,1037.7,1090.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1040.31,1004.55c-8.6-3.4-19.44-5.55-33.11-5.55-66,0-68,40-68,40S954.2,1014,1040.31,1004.55Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 941.2,
    y: 1244,
    width: 132,
    height: 8,
    transform: "translate(1497.4 1885) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1046.2,915l10,77.13s157-27.13,134-204.13c-13.94-107.25-110.8-146.53-194-140-26.27,2.06-70.79,18.2-101,41a196,196,0,0,0-49,55l103,42,58,81s27.67-26.15,54-14C1087.2,865,1081.2,919,1046.2,915Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFrame4);
export default __webpack_public_path__ + "static/media/left_frame_4.1acc489611bdde8d19299b493c8dee2f.svg";
export { ForwardRef as ReactComponent };